module.exports = __webpack_public_path__ + "media/img/baercode-ui-98034769de51aaec1ba3cedcfe1ecfe4.png";